<script>
    import { onMount, setContext } from 'svelte';
    import { mapbox, key } from './mapbox.js';
    import { textInfo } from './stores.js';

    setContext(key, {
        getMap: () => map
    });

    export let lat = 38;
    export let lon = -36;
    export let zoom = 3;

    let container;
    let map;

    onMount(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v1.12.0/mapbox-gl.css';

        // link.onload = () => {
            map = new mapbox.Map({
                container,
                style: 'mapbox://styles/mapbox/dark-v10',
                center: [lon, lat],
                zoom
            });

            var hoveredStateId = null;

        // };

        map.on('load', function () {

            map.addSource('10m-bathymetry-81bsvj', {
                type: 'vector',
                url: 'mapbox://mapbox.9tm8dx88',
                'buffer':0
            });

            map.addLayer({
                "id": "10m-bathymetry-81bsvj",
                "type": "fill",
                "source": "10m-bathymetry-81bsvj",
                "source-layer": "10m-bathymetry-81bsvj",
                "layout": {},
                "paint": {
                    "fill-outline-color": "hsla(337, 82%, 62%, 0)",
                    // cubic bezier is a four point curve for smooth and precise styling
                    // adjust the points to change the rate and intensity of interpolation
                    "fill-color": [ "interpolate",
                        [ "cubic-bezier",
                            0, 0.5,
                            1, 0.5 ],
                        ["get", "DEPTH"],
                        0,  "#b4cad9",
                        9000, "#010a40"
                    ]
                }
            }, 'land-structure-polygon');


        //add GEOJSON DATA
            map.addLayer({
                    'id': 'scatterLayer',
                    'type': 'circle',
                    'source': {
                       'type': 'geojson',
                    'data':"./data/20190813Spire_Vessels.geojson" //replace with variable later
                    },
                    'paint': {
                        'circle-color': [
                            'match',
                                ['get', 'ship_type'],
                                'Passenger','#01ff45',
                                'Fishing','#ff013d',
                                'Sailing Vessel','white',
                                'Cargo','#df00fe',
                                /* other */ '#f7ff00'
                        ],
                        "circle-radius":
                            ["interpolate", ["linear"], ["zoom"],
                                // zoom is 5 (or less) -> circle radius will be 1px
                                4, 3,
                                // zoom is 10 (or greater) -> circle radius will be 5px
                                12, 8
                        ],
                        "circle-opacity": [
                             "interpolate", ["linear"], ["zoom"],
                                    5, 0.5,
                                    12, 1
                        ],
                        "circle-blur":0.4// Nice radius value
                    }
                });

            //ADD LAYER FOR HOVER AND
            map.addLayer({
                    'id': 'scatterLayer2',
                    'type': 'circle',
                    'source': {
                       'type': 'geojson',
                    'data':"./data/20190813Spire_Vessels.geojson" //replace with variable later
                    },
                    'paint': {
                        'circle-color': [
                            'match',
                                ['get', 'ship_type'],
                                'Passenger','#01ff45',
                                'Fishing','#ff013d',
                                'Sailing Vessel','white',
                                'Cargo','#df00fe',
                                /* other */ '#f7ff00'
                        ],
                        "circle-radius": ["case",
                            ["boolean", ["feature-state", "hover"], false],
                            10,2

                        ],
                        "circle-opacity": [
                             "interpolate", ["linear"], ["zoom"],
                                    5, 0.5,
                                    12, 1
                        ]
                    }
                });

                    // When the user moves their mouse over the state-fill layer, we'll update the
            // feature state for the feature under the mouse.
            map.on('mousemove', 'scatterLayer', function (e) {
            var scatter_left_info;
            if (e.features.length > 0) {
                if (hoveredStateId) {
                    map.setFeatureState({ source: 'scatterLayer2', id: hoveredStateId },{ hover: false });

                        }
                    scatter_left_info = e.features[0].properties
                    }

                hoveredStateId = e.features[0].id;
                // let allinfo = document.getElementById('allinfo');
                // if (scatter_left_info){
                //     allinfo.innerText = JSON.stringify(scatter_left_info, null,'\t');
                // }
                textInfo.set(scatter_left_info);
                map.setFeatureState({source: 'scatterLayer2', id: hoveredStateId}, { hover: true});

            });

            // When the mouse leaves the state-fill layer, update the feature state of the
            // previously hovered feature.
            map.on('mouseleave', 'scatterLayer', function () {
                if (hoveredStateId) {
                map.setFeatureState(
                { source: 'scatterLayer2', id: hoveredStateId },
                { hover: false }
                );
                }
                hoveredStateId = null;
                });





        });




        document.head.appendChild(link);


        return () => {
            map.remove();
            link.parentNode.removeChild(link);
        };
    });
</script>

<style>
    div {
        width: 100%;
        height: 100%;
    }
</style>

<div bind:this={container}>
    {#if map}
        <slot></slot>
    {/if}
</div>